function setDataInMarkup(structuredData) {
	const structuredDataText = JSON.stringify(structuredData);
	const script = document.createElement('script');
	script.setAttribute('type', 'application/ld+json');
	script.textContent = structuredDataText;
	document.head.appendChild(script);
}

function transformApartmentData(apartment) {
	const singleUrl = options.singlePageUrl + "?id=" + apartment.apartmentId;

	return {
		"@type": "Apartment",
		name: apartment.title,
		photo: apartment.meta.thumbnailId.node.mediaItemUrl,
		url: singleUrl,
		description: apartment.flatHighlights,
		numberOfRooms: apartment.meta.numberOfRooms,
		accommodationCategory: apartment.meta.apartmentType[0],
		tourBookingPage: singleUrl,
		floorLevel: apartment.meta.floor,
		floorSize: {
			"@type": "QuantitativeValue",
			value: apartment.meta.surfaceArea,
			unitCode: "MTK"
		},
		occupancy: {
			"@type": "QuantitativeValue",
			minValue: apartment.meta.minResidents,
		},
		address: {
			"@type": "PostalAddress",
			addressLocality: apartment.meta.city,
			streetAddress: apartment.meta.address,
			postalCode: apartment.meta.zip
		},
	};
}

export function setStructuredSingleData(apartment) {
	const schema = {
		"@context": "https://schema.org",
		...transformApartmentData(apartment)
	}
	setDataInMarkup(schema);
}

export function setStructuredArchiveData(apartments) {
	const apartmentsBySchema = {
		"@context": "https://schema.org",
		"@type": "ItemList",
		numberOfItems: apartments.length,
		itemListElement: []
	}

	apartments.forEach(apartment => {
		apartmentsBySchema.itemListElement.push(transformApartmentData(apartment));
	});

	setDataInMarkup(apartmentsBySchema);
}
